var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_488397",
    "data-name": "Group 488397",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.048,
    height: 17.05,
    viewBox: "0 0 17.048 17.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_180761",
    "data-name": "Path 180761",
    d: "M89.727,121.554H74.809v.4q0,3.329,0,6.657a1.936,1.936,0,0,1-.007.3.531.531,0,0,1-1.05,0,.9.9,0,0,1-.007-.2q0-4.394,0-8.788A1.94,1.94,0,0,1,75.677,118q6.59-.006,13.181,0a1.938,1.938,0,0,1,1.931,1.927q.007,6.524,0,13.048c0,.4-.227.664-.547.653s-.516-.267-.516-.65q0-5.492,0-10.985Zm-.036-1.091c.174-.914-.24-1.423-1.164-1.417q-6.309.042-12.618,0a1.015,1.015,0,0,0-1.046,1.416Z",
    transform: "translate(-73.744 -117.993)",
    fill: "#8e92a4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180762",
    "data-name": "Path 180762",
    d: "M102.089,207.54c1.175-.033,1.322.027,1.972.794a1.665,1.665,0,0,1,2.314,1.334,5.245,5.245,0,0,1,.816.007,1.541,1.541,0,0,1,1.286,1.483c.014.954.007,1.909,0,2.863a.532.532,0,1,1-1.06.005c-.005-.888,0-1.775,0-2.663,0-.406-.212-.668-.532-.669s-.531.26-.534.667c0,.3.005.6,0,.9a.53.53,0,1,1-1.06,0c-.007-.777,0-1.554,0-2.33,0-.415-.206-.661-.539-.657s-.525.248-.527.669c0,.51,0,1.021,0,1.531,0,.381-.212.638-.522.644s-.54-.258-.541-.659c0-.743,0-1.487,0-2.23,0-.406-.213-.668-.533-.668s-.531.261-.533.668c0,.522,0,1.043,0,1.565,0,.37-.2.6-.516.609s-.545-.23-.545-.613q0-2.863,0-5.726a2.072,2.072,0,0,0-.007-.3.54.54,0,0,0-.53-.462.53.53,0,0,0-.523.469,1.657,1.657,0,0,0-.007.3q0,3.446,0,6.891c0,.294-.063.535-.36.638s-.493-.055-.686-.272a8.484,8.484,0,0,0-.895-.885,1.872,1.872,0,0,0-1.539-.359,3.02,3.02,0,0,0-.48.164c.144.156.237.274.347.374a6.109,6.109,0,0,1,1.463,2.118c.17.383.083.677-.233.815-.3.129-.572,0-.735-.367a5.037,5.037,0,0,0-1.237-1.791,1.317,1.317,0,0,1-.548-1.516,1.51,1.51,0,0,1,1.421-.872,3.091,3.091,0,0,1,2.414.746v-.406c0-1.831,0-3.662,0-5.493a1.595,1.595,0,0,1,3.17-.274,6.731,6.731,0,0,1,.023,1C102.09,206.233,102.089,206.887,102.089,207.54Z",
    transform: "translate(-93.565 -197.555)",
    fill: "#8e92a4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/access-icon.fd79daac2e933f786d6436a7828213bd.svg";
export { ForwardRef as ReactComponent };